import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["button"]
  declare readonly buttonTarget: HTMLButtonElement

  toggle(): void {
    const shouldActivate = this.buttonTarget.getAttribute("aria-expanded") === "false"

    this.buttonTarget.setAttribute("aria-expanded", shouldActivate ? "true" : "false")

    if (shouldActivate) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  hideOnFocusOut(event: FocusEvent): void {
    if (!(event.currentTarget as Node).contains(event.relatedTarget as Node)) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
